<template>
  <el-container
    id="pagar-container"
    style="justify-content:center; align-items:center"
    v-loading.fullscreen.lock="loading"
  >
    <el-col
      :xs="24"
      :sm="20"
      :md="15"
      :lg="10"
    >
      <el-row type="flex" justify="end">
        <el-col
          :xs="24"
          :sm="5"
        >
          <el-button
            type="primary"
            @click="$goBack()"
            style="width:100%"
          >
            Volver
          </el-button>
        </el-col>
      </el-row>
      <div class="cart-wrapper">
        <div class="cart-title">
          <h1 class="cart-title__inner">
            Detalle de pago
          </h1>
        </div>
        <div class="custom-table">
          <div
            class="custom-table__body"
          >
            <div class="custom-row">
              <div class="custom-row__field">
                CLAVE CATASTRAL
              </div>
              <div class="custom-row__value">
                {{ cart.propertyKey }}
              </div>
            </div>
            <div class="custom-row">
              <div class="custom-row__field">
                Referencia
              </div>
              <div class="custom-row__value">
                {{ oxxoReference }}
              </div>
            </div>
            <div class="custom-row">
              <div class="custom-row__field">
                Fecha de expiración
              </div>
              <div class="custom-row__value">
                {{ expirationDate }}
              </div>
            </div>
            <div class="custom-row">
              <div class="custom-row__field">
                total
              </div>
              <div class="custom-row__value">
                {{ $currencyFormater(cart.total) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-row>
        <router-link
          tag="button"
          to="/movil/referencia-oxxo/qr"
          class="el-button el-button--primary"
          style="width:100%"
        >
          <span>
            CÓDIGO QR
          </span>
        </router-link>
      </el-row>
      <br>
      <el-row>
        <el-col>
          <router-link
            tag="button"
            to="/movil/referencia-oxxo/barcode"
            class="el-button el-button--primary"
            style="width:100%"
          >
            <span>
              CÓDIGO DE BARRAS
            </span>
          </router-link>
        </el-col>
      </el-row>
    </el-col>
  </el-container>
</template>

<script>
import Moment from 'moment';
import { mapState } from 'vuex';

const generate = require('../../utils/generateRef');

export default {
  data() {
    return {
      loading: false,
      lineaBancos: null,
      pk: null,
      nombrecompletopropietario: null,
      total: 0,
      oxxoReference: '',
      expirationDate: '13/06/2022',
    };
  },
  computed: {
    ...mapState({
      cart: (state) => state.cart.data,
      user: (state) => state.predio.user,
    }),
  },
  methods: {
    generateRef() {
      const date = new Moment().format('DD/MM/YYYY');
      const ref = this.user.cuentadepredial;
      const { LINEA_OXXO } = generate(date, this.total, ref);
      this.oxxoReference = LINEA_OXXO;
      this.expirationDate = date;
    },
  },
  mounted() {
    this.generateRef();
  },
};
</script>

<style lang="scss" scoped>
#pagar-container {
  .el-button {
    background-color: #884E93;
    &:hover {
      opacity: 0.9;
    }
  }
  .cart-wrapper {
    margin: 10px 0px;
    border: solid #f0f0f0;
    border-width: 1px;
    .cart-title {
      border-radius: 5px 5px 0px 0px !important;
      background-color: #333333;
      color: #FFFFFF;
      padding: 10px;
      .cart-title__inner {
        font-size: 14px;
        padding: 0px !important;
        margin: 0px !important;
      }
    }
    .custom-table {
      padding-left: 10px;
      padding-right: 10px;
      .custom-row {
        display: flex;
        flex-direction: row;
        padding-top: 10px;
        padding-bottom: 10px;
        overflow: hidden;
        text-transform: uppercase;
        border: solid;
        border-width: 0px;
        border-bottom-width: 1px;
        border-color: #f0f0f0;
        &:last-child {
          border-bottom-width: 0px !important;
          .custom-row__value {
            text-align: right;
          }
        }
        .custom-row__field {
          color: #606266;
          min-width: 120px;
          width: 100%;
        }
        .custom-row__value {
          color: #0a0a0a;
          min-width: 120px;
          width: 100%;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .cart-title {
      text-align: center;
    }
  }
}
</style>
